/**
 * @author Mythily Murugan(V2E16152)
 * @class APP config
 * @description base url for all the fetch API
 * @version 1.0.0
 */
import { InjectionToken } from "@angular/core";
export let APP_CONFIG = new InjectionToken("app.config");
export const AppLogo1 = "./assets/img/brand/logo.png";
export const AppLogo2 = "../../../assets/img/brand/logo.png";
export const ClgLogo = "../../../sona clg logo.svg";
export interface IAppConfig {
  apiPoint: string;
  LocalApiPoint: string;
  LiveApiPoint: string;
  apiPointHealth: string;
  LocalApiPointHealth: string;
  LiveApiPointHealth: string;
  
}
export const IsPointV2: boolean = true;
export const IAppConfig: IAppConfig = {
  apiPoint: "https://apilcs.vee-services.com/api/v1/",
 
  LocalApiPoint: "http://172.16.6.8:1205/api/v1/",
 
  LiveApiPoint: "https://apilcs.vee-services.com/api/v1/",
 
  apiPointHealth: "https://lcshealthcheckapi.vee-services.com/",
 
  LocalApiPointHealth: "http://172.21.5.5:83/",
 
  LiveApiPointHealth: "https://lcshealthcheckapi.vee-services.com/",
};

